// @ts-check
import 'Styles/userSettings/assistentSetting.scss';
import { observer } from "mobx-react";
import React from "react";

/**
 * @param {{
 * cbMode?: boolean,
 * mainAssistentLid: string | undefined | null,
 * deleteAssistent: (arg0: string) => void,
 * makeMainAssistent: (arg0: string) => void,
 * assistent: Assistent,
 * }} props 
 * @returns {React.JSX.Element}
 */
const AssistentSetting = (props) => {
    const isMain = props.assistent.userLid === props.mainAssistentLid;
    const cbMode = props.cbMode ?? false;
    const name = props.assistent.name + (props.assistent.post ? ' - ' + props.assistent.post : '')

    return (
        <div className={'assistent-setting' + (props.assistent.deleted ? ' assistent-setting-deleted' : '')}>

            <div className='assistent-setting-title'>
                <span className='asistent-setting-title-name'>{name}</span>
                {isMain ? (<b>&nbsp;(главный)</b>) : ""}
            </div>

            {
                cbMode ? '' :
                    <div className='assistent-setting-buttons'>
                        <button
                            id={`assistent-main-button-${props.assistent.userLid}`}
                            onClick={() => props.makeMainAssistent(props.assistent.userLid)}
                            className={'main-button ' + (isMain ? 'disabled' : '')}>
                            Сделать главным
                        </button>

                        <button
                            id={`assistent-delete-button-${props.assistent.userLid}`}
                            onClick={(e) => props.deleteAssistent(props.assistent.userLid)}
                            className={"red-button"}>
                            Удалить
                        </button>
                    </div>
            }
        </div>
    )
}

export default observer(AssistentSetting);